// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1215":"db0b09ee","4618":"db0b09ee"}[chunkId] + ".chunk.css";
};